import { DirectionType } from 'antd/lib/config-provider';
import { Locale } from 'antd/lib/locale-provider';
import EnLang from './entries/en-US';
import FaLang from './entries/fa_IR';

interface ILang {
  messages: Record<string, string>;
  direction: DirectionType;
  antd: Locale;
  locale: string;
}

export const AppLocale: { [lang: string]: ILang } = {
  fa: {
    antd: FaLang.antd,
    direction: 'rtl',
    locale: FaLang.locale,
    messages: FaLang.messages,
  },
  en: {
    antd: EnLang.antd,
    direction: 'ltr',
    locale: EnLang.locale,
    messages: EnLang.messages,
  },
};

export const getLocaleMsg = (): Record<string, string> => {
  const isFa = localStorage.getItem('language') === 'fa-IR';
  return AppLocale[isFa ? 'fa' : 'en'].messages;
};
